export default {
  label: {
    title: 'Filtros globais aplicados',
  },
};
